import Paper from '@mui/material/Paper';

import { constants } from 'lib/constants';

export const BannerLogo = () => {
	return (
		<Paper
			
		>
			
		</Paper>
	);
};
